// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");

function Tickets(props) {
  var match = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var hasPermission = match[0];
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var match$1 = url.path;
  var selected;
  if (match$1 && match$1.hd === "tickets") {
    var match$2 = match$1.tl;
    if (match$2) {
      switch (match$2.hd) {
        case "agent_summary" :
            selected = match$2.tl ? "" : "agent_summary";
            break;
        case "downloadList" :
            selected = match$2.tl ? "" : "downloads";
            break;
        case "manage" :
            selected = match$2.tl ? "" : "overview";
            break;
        case "work" :
            selected = match$2.tl ? "" : "work_on_tickets";
            break;
        default:
          selected = "";
      }
    } else {
      selected = "";
    }
  } else {
    selected = "";
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        Curry._1(hasPermission, "ManageTickets") || Curry._1(hasPermission, "CreateTicket") ? JsxRuntime.jsx("a", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "m-auto inline-block align-middle max-h-full\n                  max-w-full w-auto h-auto inset-0 absolute " + (
                                              selected === "overview" ? "filter-white" : ""
                                            ),
                                            title: "Overview",
                                            src: Image$ReactHooksTemplate.sidebarOverview
                                          }),
                                      className: "w-16 h-16 relative hover:bg-palatinateblue sidebar " + (
                                        selected === "overview" ? "bg-palatinateblue border-palatinateblue" : ""
                                      )
                                    }),
                                href: "/tickets/manage/all"
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                        JsxRuntime.jsx("a", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "m-auto inline-block align-middle max-h-full\n              max-w-full w-auto h-auto inset-0 absolute " + (
                                            selected === "work_on_tickets" ? "filter-white" : ""
                                          ),
                                          title: "Work on Tickets",
                                          src: Image$ReactHooksTemplate.workOnTickets
                                        }),
                                    className: "w-16 h-16 relative hover:bg-palatinateblue sidebar " + (
                                      selected === "work_on_tickets" ? "bg-palatinateblue border-palatinateblue" : ""
                                    )
                                  }),
                              href: "/tickets/work/all"
                            }),
                        Curry._1(hasPermission, "ManageTickets") ? JsxRuntime.jsx("a", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "m-auto inline-block align-middle max-h-full\n                  max-w-full w-auto h-auto inset-0 absolute " + (
                                              selected === "agent_summary" ? "filter-white" : ""
                                            ),
                                            title: "Agent Summary",
                                            src: Image$ReactHooksTemplate.agentSummary
                                          }),
                                      className: "w-16 h-16 relative hover:bg-palatinateblue sidebar " + (
                                        selected === "agent_summary" ? "bg-palatinateblue border-palatinateblue" : ""
                                      )
                                    }),
                                href: "/tickets/agent_summary"
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                        Curry._1(hasPermission, "ManageTickets") ? JsxRuntime.jsx("a", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "m-auto inline-block align-middle max-h-full\n                  max-w-full w-auto h-auto inset-0 absolute " + (
                                              selected === "downloadsList" ? "filter-white" : ""
                                            ),
                                            title: "Download List",
                                            src: Image$ReactHooksTemplate.downloadBox
                                          }),
                                      className: "w-16 h-16 relative hover:bg-palatinateblue sidebar " + (
                                        selected === "downloadsList" ? "bg-palatinateblue border-palatinateblue" : ""
                                      )
                                    }),
                                href: "/tickets/downloadList"
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                        Curry._1(hasPermission, "ManageTickets") ? JsxRuntime.jsx("a", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "m-auto inline-block align-middle max-h-full\n                  max-w-full w-6 h-6 inset-0 absolute " + (
                                              selected === "ticketsHeaders" ? "filter-white" : ""
                                            ),
                                            title: "Tickets Headers",
                                            src: Image$ReactHooksTemplate.listdown
                                          }),
                                      className: "w-16 h-16 relative hover:bg-palatinateblue sidebar " + (
                                        selected === "ticketsHeaders" ? "bg-palatinateblue border-palatinateblue" : ""
                                      )
                                    }),
                                href: "/tickets/tickets_headers"
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                      ],
                      className: "pr-54-px min-h-screen w-16 bg-ghostwhite border-r border-gray-300"
                    }),
                JsxRuntime.jsx("div", {
                      children: props.content,
                      style: {
                        width: "calc(100vw - 4rem)"
                      }
                    })
              ],
              className: "flex"
            });
}

var make = Tickets;

exports.make = make;
/* react Not a pure module */
